import { useRef, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsAuthenticated, getUserFirstName, getUserLastName, getUserUrl, getUserEmail, getUserPhoneNumber, getUserCountry } from '../../../redux/auth/auth-selectors';
import { googleLogin, logOut, updateUser } from '../../../redux/auth/auth-operations';


import { ReactComponent as LocateProfileIcon } from '../../img/locateProfileIcon.svg';
import { ReactComponent as LogoutProfileIcon } from '../../img/logoutProfileIcon.svg';
import { ReactComponent as TelProfileIcon } from '../../img/telProfileIcon.svg';
import { ReactComponent as UserProfileIcon } from '../../img/userProfileIcon.svg';

import { createUseStyles } from "react-jss";

const useStales = createUseStyles({
    logout: {
        width: 264,
        height: 40,
        backgroundColor: 'transparent',
        border: 'none',
        textAlign: 'start',
        boxSizing: 'border-box',
        color: '#fff',
        cursor: 'pointer',
    },
    userAccountInputs: {
        width: 264,
        textAlign: 'start',
        marginLeft: 5,

    },
    userAccountInput: {
        boxSizing: 'border-box',
        width: 264,
        padding: '5px 0px',
        backgroundColor: 'transparent',
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        borderBottom: {
            color: '#AAAAAA',
            width: 1,
            style: 'solid'
        },
        color: '#fff',
        height: 40,
    },
    userAccountBtn: {
        width: 264,
        height: 40,
        backgroundColor: '#337AA6',
        border: {
            color: '#337AA6',
            width: 1,
            style: 'solid'
        },
        boxSizing: 'border-box',
        borderRadius: 8,
        color: '#fff',
        cursor: 'pointer',
        marginTop: 20,

        '&:hover': {
            backgroundColor: '#225A7C',
            border: '1px solid #225A7C',
        },

        '&:active': {
            backgroundColor: '#16405A',
            border: '1px solid #16405A'
        }
    },
});



export default function ProfileContent({ openUserAccount, setOpenUserAccount }) {
    const dispatch = useDispatch();
    const classes = useStales('');

    const loginStatus = useSelector(getIsAuthenticated);
    const userEmail = useSelector(getUserEmail);
    const userFirstName = useSelector(getUserFirstName);
    const userLastName = useSelector(getUserLastName);
    const userPhoneNumber = useSelector(getUserPhoneNumber);
    const userCountry = useSelector(getUserCountry);

    const [isEditFormOpen, setIsEditFormOpen] = useState(false);
    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [number, setNumber] = useState("");
    const [country, setCountry] = useState("");

    const profileContent = useRef(null);


    useEffect(() => {
        setName(userFirstName ? userFirstName : "")
        setSurname(userLastName ? userLastName : "")
        setNumber(userPhoneNumber ? `+${userPhoneNumber}` : "")
        setCountry(userCountry ? userCountry : "")
    }, [loginStatus]);

    const handleSubmit = useCallback(e => {
        if (name !== userFirstName || surname !== userLastName || number !== userPhoneNumber || country !== userCountry) {
            const payload = {
                firstName: name,
                lastName: surname,
                phoneNumber: number,
                country: country
            };
            dispatch(updateUser(payload));
            setIsEditFormOpen(prev => !prev)
        };

    }, [dispatch, name, surname, number, country, userFirstName, userLastName, userPhoneNumber, userCountry]);

    const handleChangeName = (e) => { setName(e.target.value) };

    const handleChangeSurname = (e) => { setSurname(e.target.value) };

    const handleChangeNumber = (e) => {
        setNumber(e.target.value)
    };

    const handleChangeCountry = (e) => { setCountry(e.target.value) };


    useEffect(() => {

        if (!openUserAccount) return;

        const handleClick = e => {
            if (!profileContent.current) return;

            if (profileContent.current && !profileContent.current.contains(e.target)) {
                setOpenUserAccount(false);
            }

        };


        document.addEventListener("mousedown", handleClick);

        return () => {
            document.removeEventListener("mousedown", handleClick);
        };

    }, [openUserAccount, setOpenUserAccount, profileContent]);

    const onLogout = useCallback(() => dispatch(logOut()), [dispatch]);


    return (
        <div ref={profileContent} style={{
            position: 'absolute',
            width: 294, minHeight: 256, backgroundColor: '#5D5D5E', right: 10, top: 50, zIndex: 1000, right: 24,
            top: 110, borderRadius: 8, padding: 8
        }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 5px' }}>
                <div>
                    <h3>Profile</h3>
                    <p style={{ marginTop: 8 }}>{userEmail}</p>

                </div>
                {isEditFormOpen ? (
                    <button onClick={() => handleSubmit()} style={{ width: 64, height: 36, padding: '8px 12px 8px 12px', border: '1px solid #FFFFFF33', color: '#FFFFFF', backgroundColor: '#FFFFFF33', borderRadius: 8 }}>Done</button>

                ) : (
                    <button onClick={() => setIsEditFormOpen(prev => !prev)} style={{ width: 64, height: 36, padding: '8px 12px 8px 12px', border: '1px solid #FFFFFF33', color: '#FFFFFF', backgroundColor: '#FFFFFF33', borderRadius: 8 }}>Edit</button>
                )}

            </div>
            <hr style={{ borderColor: '#878790', align: 'left' }} />

            {isEditFormOpen ? (
                <form>
                    <div className={classes.userAccountInputs}>
                        <div style={{ display: 'flex', marginTop: 8, alignItems: 'baseline' }}>
                            <UserProfileIcon style={{ marginRight: 8 }} />
                            <input id='name' className={classes.userAccountInput}
                                type="text"
                                value={name}
                                onChange={handleChangeName}
                            />

                        </div>

                        <div style={{ display: 'flex', marginTop: 8, alignItems: 'baseline' }}>
                            <UserProfileIcon style={{ marginRight: 8 }} />
                            <input id='surname' className={classes.userAccountInput}
                                type="text"
                                value={surname}
                                onChange={handleChangeSurname}
                            />
                        </div>

                        <div style={{ display: 'flex', marginTop: 8, alignItems: 'baseline' }}>
                            <TelProfileIcon style={{ marginRight: 8 }} />
                            <input id='number' className={classes.userAccountInput}
                                type="tel" name="phone" placeholder="+18008066453" min="2"
                                value={number}
                                onChange={handleChangeNumber}
                            />
                        </div>

                        <div style={{ display: 'flex', marginTop: 8, alignItems: 'baseline' }}>
                            <LocateProfileIcon style={{ marginRight: 8 }} />
                            <input id='country' className={classes.userAccountInput}
                                type="text" placeholder="US" pattern="[A-Z]{2}"
                                value={country}
                                onChange={handleChangeCountry}
                            />
                        </div>
                    </div>

                    {/* <button type="submit" className={classes.userAccountBtn}>Save</button> */}
                </form>

            ) : (
                <div style={{ padding: '0px 5px' }}>
                    <div style={{ display: 'flex', marginTop: 8 }}>
                        <p style={{ margin: '10px 8px 0px 0px' }}><UserProfileIcon style={{ marginRight: 8 }} />{name} {surname}</p>
                    </div>
                    <p style={{ margin: '10px 8px 0px 0px' }}><TelProfileIcon style={{ marginRight: 8 }} />{number}</p>
                    <p style={{ margin: '10px 8px 0px 0px' }}><LocateProfileIcon style={{ marginRight: 8 }} />{country}</p>
                    {/* <button type="submit" className={classes.userAccountBtn}>Save</button> */}
                </div>

            )}

            <hr style={{ borderColor: '#878790', align: 'left' }} />


            <button type="button" onClick={onLogout} className={classes.logout}><LogoutProfileIcon style={{ marginRight: 8 }} />Sign out</button>
            {/* </div> */}

        </div>
    );
}
